import { forwardRef } from "react";
import { Form, Settings, SettingsItem, Select } from "ui";
import { MenuItem } from "@mui/material";
import StripeModel from "./types/StripeModel";
import FormRef from "../types/FormRef";

type StripeUpdateFormProps = {
    data: StripeModel;
    errors: any;
    loading: boolean;
    onSubmit: (data: StripeModel) => void;
};

const StripeUpdateForm = forwardRef<FormRef, StripeUpdateFormProps>(
    ({ data, errors, loading, onSubmit }, ref) => {
        return (
            <Form
                ref={ref}
                data={data}
                errors={errors}
                fields={{
                    environment: { default: "production" },
                }}
                loading={loading}
                onSubmit={onSubmit}
                preventLeftForm
                unsaved={false}
            >
                {(context: any) => {
                    return (
                        <>
                            <Settings>
                                <SettingsItem label="Environment">
                                    <Select
                                        fullWidth
                                        id="environment"
                                        margin="none"
                                    >
                                        <MenuItem value="test">Test</MenuItem>
                                        <MenuItem value="production">
                                            Production
                                        </MenuItem>
                                    </Select>
                                </SettingsItem>
                            </Settings>
                        </>
                    );
                }}
            </Form>
        );
    },
);

export default StripeUpdateForm;
